import type { TextProps } from '@chakra-ui/react';
import { Text } from '@chakra-ui/react';

type AddressProps = {
  // The full address string
  address: string;
  // The number of leading characters to display when address is not expanded.
  leadingChars?: number;
  // The number of tailing characters to display when address is not expanded.
  tailingChars?: number;
  // Flag to control whether the full address or a shortened form should be displayed.
  isExpanded?: boolean;
} & TextProps;

export const Address: React.FC<AddressProps> = ({
  address,
  leadingChars = 3,
  tailingChars = 3,
  isExpanded = false,
  ...rest
}) => {
  if (!address) return null;
  if (isExpanded) return <Text {...rest}>{address}</Text>;

  return (
    <Text {...rest}>
      {address.slice(0, leadingChars)}...{address.slice(-tailingChars)}
    </Text>
  );
};

// eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
Address.displayName = 'Address';
